import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { cn } from '@utils';

const RadioCard = ({
  id,
  title,
  description = "",
  onClick,
  checked,
  disabled = false,
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    onClick();
  };

  const shouldWrap = /\s/.test(description);

  return (
    <button
      key={id}
      checked={checked}
      onClick={handleClick}
      aria-label={title}
      disabled={disabled}
      className={cn(
        "flex-1 min-w-0 group relative flex text-left cursor-pointer rounded-lg border border-zinc-300 bg-white p-4 shadow-sm",
        checked && "outline-none border-primary ring-1 ring-primary",
        disabled && "border-zinc-200"
      )}
    >
      <span className="flex flex-1 min-w-0 flex-col">
        <span
          className={cn(
            "block text-sm font-medium text-zinc-900",
            disabled && "text-zinc-400"
          )}
        >
          {title}
        </span>

        {description && (
          <span
            className={cn(
              "mt-1 text-sm text-zinc-500 min-w-0",
              shouldWrap
                ? "whitespace-normal break-words"
                : "truncate whitespace-nowrap overflow-hidden text-ellipsis",
              disabled && "text-zinc-400/70"
            )}
          >
            {description}
          </span>
        )}
      </span>

      <div className="w-5 flex flex-col items-center">
        {checked && (
          <CheckCircleIcon aria-hidden="true" className="size-5 text-primary" />
        )}
      </div>
    </button>
  );
};

export default RadioCard;